import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

const AdminGuard = ({ children }) => {
  const { status } = useAdminAuth();
  if (status === "loading") {
    return (
      <div
        data-testid="admin-loading"
        style={{
          minHeight: "100vh",
          background: "#0A0A0A",
          color: "#F5F1E8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Montserrat, sans-serif",
          letterSpacing: "0.24em",
          fontSize: 11,
          textTransform: "uppercase",
        }}
      >
        Authenticating…
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default AdminGuard;
